var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { useEffect } from 'react';
import { useLegalsContext } from '../LegalsProvider';
import { REGEX_INDEXED_LEGAL } from '../utils/constants';
import findIndexedLegals from '../utils/findIndexedLegals';
import findNonIndexedLegals from '../utils/findNonIndexedLegals';
import splitLegalContent from '../utils/splitLegalContent';
/**
 * Component that handles the interactions with the `LegalsProvider`.
 *
 * All unknown props will be forwarded to the footnote link component`.
 */
const LegalString = (_a) => {
    var { children, footnoteLinkComponent: FootnoteLinkComponent } = _a, props = __rest(_a, ["children", "footnoteLinkComponent"]);
    const { addIndexedSlugs, addNonIndexedSlugs, copy, indexedLegalSlugs, legalsMap, onClickFootnoteLink } = useLegalsContext();
    useEffect(() => {
        const indexedSlugs = findIndexedLegals(children);
        const nonIndexedSlugs = findNonIndexedLegals(children);
        addIndexedSlugs(indexedSlugs);
        addNonIndexedSlugs(nonIndexedSlugs);
    }, [children, addIndexedSlugs, addNonIndexedSlugs]);
    const items = splitLegalContent(children);
    return (_jsx(_Fragment, { children: items.map((item) => {
            const match = REGEX_INDEXED_LEGAL.exec(item);
            if (!match) {
                return item;
            }
            const slug = match[2];
            const legal = legalsMap[slug];
            if (!legal) {
                return null;
            }
            return (_createElement(FootnoteLinkComponent, Object.assign({}, props, { key: legal.slug, copy: copy, number: indexedLegalSlugs.indexOf(slug) + 1, onClick: onClickFootnoteLink })));
        }) }));
};
LegalString.displayName = 'LegalString';
export default LegalString;
